import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';

const PcModelOptionImageCarousel = ({ images, width, height, isHovered }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    let intervalId;
    if (isHovered) {
      intervalId = setInterval(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 1500); // Change image every 1.5 seconds
    } else if (intervalId) {
      clearInterval(intervalId);
    }
    return () => clearInterval(intervalId);
  }, [isHovered, images.length]);

  return (
    <div className="option-image-carousel" style={{ width, height }}>
      {images.map((image, index) => (
        <div
          key={index}
          className={`image-wrapper ${
            index === currentImageIndex ? 'visible' : 'hidden'
          }`}
        >
          <Image
            draggable={false}
            src={image.src}
            alt={image.alt}
            width={width}
            height={height}
          />
        </div>
      ))}
      <style jsx>{`
        .option-image-carousel {
          position: relative;
        }
        .image-wrapper {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          transition: opacity 0.5s ease-in-out;
        }
        .image-wrapper.visible {
          opacity: 1;
          z-index: 1;
        }
        .image-wrapper.hidden {
          opacity: 0;
          z-index: 0;
        }
      `}</style>
    </div>
  );
};

PcModelOptionImageCarousel.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
    }),
  ).isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  isHovered: PropTypes.bool.isRequired,
};

export default PcModelOptionImageCarousel;
